module.exports = __webpack_public_path__ + "static/media/founder2.64f74ab1.jpg";